import React from "react";
import { Modal, ModalContent, ModalOverlay } from "@chakra-ui/modal";

type CommonModalProps = {
  size?:
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "4xl"
    | "5xl"
    | "6xl"
    | "full";
  children: React.ReactNode;
  isOpen: boolean;
  closeOnOverlayClick?: boolean;
  onClose: () => void;
};

const CommonModal: React.FC<CommonModalProps> = (props) => {
  const { size, children, isOpen, closeOnOverlayClick, onClose } = props;

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      size={size}
      isCentered
      scrollBehavior="outside"
      closeOnOverlayClick={closeOnOverlayClick ?? true}
    >
      <ModalOverlay />
      <ModalContent className="!rounded-[1.6rem]">{children}</ModalContent>
    </Modal>
  );
};

export default CommonModal;
